export default __webpack_public_path__ + "static/media/iso_9001.3d024f2d.jpg";